import footerImage from '../../../assets/historia/FooterCapsos.jpeg';

export const footerContent = {
  image: footerImage,
  kicker: 'CAPSOS TELECOMUNICACIONES',
  title: 'Conectando a Santa Rosa de Osos con el mundo.',
  description: 'Tecnología, comunicación y entretenimiento para acercar hogares, empresas y comunidades con soluciones confiables de conectividad.',
  whatsappMessage: 'Hola, quiero recibir información sobre los servicios de CAPSOS Telecomunicaciones.',
  primaryActionLabel: 'Hablar con un asesor',
  secondaryActionLabel: 'Volver arriba',
};
